export const USER_GET = 'USERS/GET';
export const EDUCATOR_CREATE = 'USERS/CREATE_EDUCATOR';
export const USER_CHANGE = 'USERS/CHANGE';
export const USER_SELECT = 'USERS/SELECT';
export const USERS_MERGE = 'USERS/MERGE';
export const STUDENT_CREATE = 'USERS/CREATE_STUDENT';
export const STUDENT_UPDATE = 'USERS/UPDATE_STUDENT';
export const PROFESSIONAL_CREATE = 'USERS/PROFESSIONAL_CREATE';
export const PROFESSIONAL_UPDATE = 'USERS/PROFESSIONAL_UPDATE';

